import { Splide } from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';


const carousel = () => {
  function getDeviceFlags() {
    const w = window.innerWidth;

    return {
      pc: w >= 992,
      tablet: w >= 768 && w < 992,
      sp: w < 768
    };
  }
  let device = getDeviceFlags();

  const planListSliderElm = document.querySelector('.js-planListSlider');
  if(planListSliderElm) {
    const planListSlider = new Splide(planListSliderElm, {
      type: 'loop',
      drag: 'free',
      arrows: false,
      pagination: false,
      gap: "2.6rem",
      fixedWidth: '32rem',
      autoScroll: {
        speed: 1.5,
        pauseOnHover: device.pc ? true : false,
        pauseOnFocus: false,
      },
    });
    planListSlider.mount( { AutoScroll } );
  }

  const introSliderElms = document.querySelectorAll('.js-introSlider');
  if(introSliderElms.length) {
    introSliderElms.forEach(elm => {
      let isReverse = elm.getAttribute('data-reverse') === 'true' ? true : false;
      const introSlider = new Splide(elm, {
        type: 'loop',
        drag: false,
        arrows: false,
        pagination: false,
        gap: device.pc ? '6rem' : device.tablet ? '5rem' : '4.4rem',
        fixedHeight: device.pc ? '24.8rem' : device.tablet ? '24.8rem' : '18rem',
        autoWidth: true,
        autoScroll: {
          speed: isReverse ? -1 : 1,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      });
      introSlider.mount( { AutoScroll } );
    });
  }

  const planDetailSlider = document.querySelector('.js-planModalSlider');
  if(planDetailSlider) {
    let modalOpenDuration = 0;
    let dataActiveIndex = planDetailSlider.getAttribute('data-active');

    const splide = new Splide(planDetailSlider, {
      type: 'fade',
      rewind: true,
      arrows: true,
      drag: false,
      pagination: false,
    });
    splide.mount();


    const planModalSliderTriggerElms = document.querySelectorAll('.js-planModalSliderTrigger');
    planModalSliderTriggerElms.forEach((modal, index) => {
      modal.addEventListener('click', () => {
        splide.go(index);
      });
    });

    const planModalListTriggerElms = document.querySelectorAll('.js-planModalListTrigger');
    planModalListTriggerElms.forEach((modal) => {
      let index = parseInt(modal.getAttribute('data-id'));
      modal.addEventListener('click', () => {
        splide.go(index);
      });
    });

    const planModalMoreTriggerElms = document.querySelectorAll('.js-planModalMoreTrigger');
    planModalMoreTriggerElms.forEach((modal) => {
      let index = parseInt(modal.getAttribute('data-id'));
      modal.addEventListener('click', () => {
        splide.go(index);
      });
    });
  }

  const planDetailSliderElms = document.querySelectorAll('.js-planDetailSlider');
  if(planDetailSliderElms.length) {
    planDetailSliderElms.forEach(elm => {
      new Splide(elm, {
        type: 'loop',
        arrows: false,
        pagination: true,
        autoplay: true,
        interval: 3000,
      }).mount();
    });
  }
}

const init = () => {
  carousel();
}
export default init;